/* ============================================================================
   WHO IS STAFF

   ⚠ THIS LIST MIRRORS THE SERVER'S "staff" POLICY in Program.cs. It is not a
   second opinion and it is never the authority — the server decides. It exists
   so the client can avoid firing requests it KNOWS will be refused.

   The case that produced it: `CampusPicker` renders in `AppShell` for every
   signed-in user and asked `/api/institutions` unconditionally, on the reasoning
   that "the server narrows the list, so asking on behalf of a teacher is safe".
   True for a teacher. A parent is not staff, so the endpoint answers 403 — on
   every page load, for every parent, forever. Caught and swallowed, so nothing
   broke; it just filled every parent's console and every server log with
   authorisation failures that were not failures of anything.

   ⚠ WHY THAT MATTERS BEYOND TIDINESS: the day you alert on 403s — and you should
   — a constant background of expected ones makes a real intrusion invisible.

   ⚠ DRIFT IS THE OBVIOUS RISK. Add a staff role on the server, forget this file,
   and that role loses its campus picker with no error anywhere. So
   `tools/wirecheck.mjs` compares this list against the policy in Program.cs and
   fails the sweep when they disagree.
   ========================================================================== */

export const STAFF_ROLES = [
  'TrustAdmin',
  'CampusAdmin',
  'Principal',
  'Accountant',
  'Teacher',
  'LabTechnician',
  'StoreKeeper',
  'SportsCoordinator',
  'TransportManager',
  'Receptionist',
  'HrManager',
] as const;

/** True when this role is employed by the school — i.e. would pass the server's "staff" policy. */
export function isStaffRole(role: string | null | undefined): boolean {
  return !!role && (STAFF_ROLES as readonly string[]).includes(role);
}
